import type { FeaturePageCardItem } from "@/features/feature-page/feature-page-card";
import { FeaturePageVisual } from "@/features/feature-page/feature-page-visual";
import { buildCdnRenderPath } from "@garimpa/lib/buildCdnRenderPath";

interface FeaturePageCardDecorationProps {
  item: FeaturePageCardItem;
  image: (NonNullable<FeaturePageCardItem["image"]> & { sizes: string }) | null;
  familyLabel?: string;
  priority: boolean;
}

export function FeaturePageCardDecoration({
  item,
  image,
  familyLabel,
  priority,
}: FeaturePageCardDecorationProps) {
  return (
    <>
      {image ? (
        <FeaturePageVisual
          visual={image}
          decorative
          priority={priority}
          className="absolute inset-0 h-full w-full object-cover transition duration-700 ease-out group-hover:scale-105"
        />
      ) : null}
      {item.emblemUrl ? (
        <img
          src={buildCdnRenderPath(item.emblemUrl, { width: 150, format: "webp" })}
          alt={item.emblemLabel ?? item.collectionLabel ?? item.title}
          width={150}
          height={150}
          className="absolute left-5 top-5 z-10 size-16 rounded-2xl border border-white/20 bg-black/30 p-1.5 object-contain shadow-lg backdrop-blur-md transition duration-300 group-hover:-rotate-2 group-hover:scale-105 motion-reduce:transition-none sm:left-7 sm:top-7 sm:size-20"
        />
      ) : null}
      {familyLabel ? (
        <span className="absolute right-5 top-5 z-10 rounded-full border border-white/20 bg-black/35 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-white/90 backdrop-blur-md sm:right-7 sm:top-7">
          {familyLabel}
        </span>
      ) : null}
    </>
  );
}
